import React from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  return (
    <header className="bg-white shadow-md">
      <div className="max-w-6xl mx-auto flex justify-between items-center px-4 py-4">
        <Link to="/" className="text-2xl font-bold font-serif text-gray-800">
          Named by <strong>God</strong>
        </Link>

        <nav className="space-x-6 text-gray-700">
          <Link to="/" className="hover:text-gray-900">Home</Link>
          <Link to="/about" className="hover:text-gray-900">About&nbsp;us</Link>
          <Link to="/books/de-us" className="hover:text-gray-900">Books</Link>
          <Link to="/join" className="hover:text-gray-900">Join&nbsp;us</Link>
        </nav>
      </div>
    </header>
  );
}
